import React, { useRef } from "react";
import { useNavigate } from "react-router-dom";

import TopBottomImgContent from "../components/Common/TopBottomImgContent";
import HeadernDescription from "../components/Common/HeadernDescription";
import LandingHero from "../components/Common/LandingHero";
import data from "../content.json";
import DigitalInnovation from "../components/Home/DigitalInnovation";
import AvexSection from "../components/OneCare/AvexaSection";
import OneCareWorks from "../components/OneCare/OneCareWorks";
import InsightSection from "../components/OneCare/InsightSection";
import { Link } from "react-router-dom";
import CTASection from "../components/Common/CtaSection";

const {
  hero,
  sec4HeadingPara,
  sec6HeadingPara,
  keyServices8,
  sec8HeadingPara,
  keyServices5,
  sec5HeadingPara,
  keyServices4,
  sec2HeadingPara,
  keyServices2,
} = data.onecare;

const OneCare = () => {
  const navigate = useNavigate();

  const handleScheduleDemo = () => {
    navigate("/get-in-touch?purpose=Product Demo");
  };

  const handleTalkExperts = () => {
    navigate("#");
  };

  const scrollRef = useRef(null);

  const scrollNext = () => {
    if (scrollRef.current) {
      // Scrolls by the width of one card (approximately)
      const cardWidth = scrollRef.current.offsetWidth / 2;
      scrollRef.current.scrollBy({ left: cardWidth, behavior: "smooth" });
    }
  };

  const scrollPrev = () => {
    if (scrollRef.current) {
      // Scrolls back by the same width
      const cardWidth = scrollRef.current.offsetWidth / 2;
      scrollRef.current.scrollBy({ left: -cardWidth, behavior: "smooth" });
    }
  };

  return (
    <>
      <div className="relative z-20 overflow-visible">
        <LandingHero data={data.onecare.hero} />
      </div>
      <div className="px-4 md:px-0">
        {/* 2nd Section */}
        <div className="relative z-10 md:px-0 py-10 md:py-16 overflow-visible">
          <InsightSection section={keyServices2}></InsightSection>
        </div>

        {/* 3rd Section */}
        <AvexSection></AvexSection>

        {/* 4th Section */}
        <div className="md:px-10 py-10 md:py-20">
          <HeadernDescription
            section={sec4HeadingPara}
            align="left"
          ></HeadernDescription>
          {/* <OneCareWorks></OneCareWorks> */}
          <OneCareWorks section={keyServices4}></OneCareWorks>
        </div>

        {/* 5th Section */}
        <div className="md:px-10 py-10 md:pb-5">
          <HeadernDescription
            section={sec5HeadingPara}
            align="left"
          ></HeadernDescription>

          <DigitalInnovation
            section={keyServices5}
            columns={4}
            arrowIcon={true}
            cardHeight="10vh"
          />
        </div>

        {/* 6th Section */}
        <div className="md:px-10 py-10 md:py-20">
          <HeadernDescription
            section={sec6HeadingPara}
            align="left"
          ></HeadernDescription>

          <div className="mx-auto">
            {/* Grid Container */}
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-1 xl:grid-cols-2 gap-8">
              {[
                {
                  id: "01",
                  title: "Patient Onboarding",
                  desc: "Capture patient details and initiate their care journey seamlessly.",
                  img: "/assets/avexaOneCare/keyServices6-1.svg",
                },
                {
                  id: "02",
                  title: "Care Interaction",
                  desc: "Enable smooth communication and engagement between patients and providers.",
                  img: "/assets/avexaOneCare/keyServices6-3.svg",
                },
                {
                  id: "03",
                  title: "Data & Insights",
                  desc: "Continuously collect health data and transform it into actionable insights.",
                  img: "/assets/avexaOneCare/keyServices6-2.svg",
                },
                {
                  id: "04",
                  title: "Continuous Care",
                  desc: "Ensure ongoing monitoring, follow-ups, and long-term patient support.",
                  img: "/assets/avexaOneCare/keyServices6-4.svg",
                },
              ].map((item) => (
                <div
                  key={item.id}
                  className="flex flex-col md:flex-row overflow-hidden rounded-2xl shadow-sm border border-slate-100"
                >
                  {/* Left: Image (40% width) */}
                  <div className="w-full md:w-[40%] h-64 md:h-auto">
                    <img
                      src={item.img}
                      alt={item.title}
                      className="w-full h-full object-cover"
                    />
                  </div>

                  {/* Right: Content Area (60% width) */}
                  <div className="relative w-full md:w-[60%] bg-[#F8FAFF] p-8 md:p-10 flex flex-col justify-center sm:h-44">
                    {/* Background Ghost Number */}
                    <span className="absolute bottom-[-10px] right-4 text-7xl md:text-8xl font-bold text-[#E6EEFF] select-none z-0">
                      {item.id}
                    </span>

                    {/* Content (Z-index ensure text is above number) */}
                    <div className="relative z-10">
                      <h3 className=" font-bold  mb-3">{item.title}</h3>
                      <p className=" md:text-base text-[#5569A0] leading-relaxed max-w-[240px]">
                        {item.desc}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* 7th Section */}
        <section className="py-16 md:py-24 bg-white md:px-10">
          <div className=" mx-auto">
            {/* Header Section */}
            <div className="mb-16 text-center md:text-left">
              <span className=" font-medium  md:text-base mb-4 block">
                Enterprise Foundation
              </span>
              <h2 className="font-normal text-black mb-8">
                Enterprise-ready by design
              </h2>
              <p className="text-[#4A4A4A] font-light">
                Built for the rigorous demands of enterprise healthcare—secure,
                scalable, and interoperable.
              </p>
            </div>

            {/* Features Grid */}
            <div className="">
              <div
                className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 
                gap-y-3 md:gap-y-12 gap-x-12 
                max-w-md md:max-w-full mx-auto"
              >
                {[
                  "API-first, microservices architecture",
                  "FHIR-compliant interoperability",
                  "Multi-tenant, scalable platform",
                  "Secure, compliant, privacy-first",
                  "Cloud-native deployment",
                  "Real-time processing and analytics",
                ].map((feature, index) => (
                  <div
                    key={index}
                    className="flex items-start gap-3 
                 justify-start md:justify-start"
                  >
                    {/* Fixed Bullet Column */}
                    <div className="w-4 flex justify-center mt-1">
                      <span className="h-3 w-3 bg-[#1D76D2] rounded-full" />
                    </div>

                    {/* Text */}
                    <p className="text-[#2D2D2D] font-light text-left">
                      {feature}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* 8th Section */}
        <div className="w-full">
          <div className="lg:px-36">
            <HeadernDescription
              section={sec8HeadingPara}
              align="center"
            ></HeadernDescription>
            <TopBottomImgContent
              section={keyServices8}
              imgHeight="20vh"
              cardHeight="20vh"
            ></TopBottomImgContent>
          </div>
        </div>

        {/* 9th section */}
        {/* <section className="relative w-full py-10 md:py-20 bg-white"> */}
        {/* The Main Container for the Background Image */}
        {/* <div className="relative w-full h-[450px] md:h-[480px] overflow-hidden">
            <img
              src="/assets/avexaOneCare/keyServices9.svg"
              alt="Healthcare collaboration"
              className="w- md:w-[90vw] h-full object-cover"
            />

            <div className="absolute inset-y-6  md:inset-y-14 left-4 md:left-[15%] right-0 bg-[#F4F7FF]/90 backdrop-blur-md rounded-l-2xl shadow-2xl border-l border-y border-white/20"> */}
        {/* Absolute centered content relative to PAGE */}
        {/* <div className="absolute inset-0 flex items-center justify-center px-6 md:px-10">
                <div className="w-full max-w-3xl text-center mx-auto ">
                  <h2 className="font-bold  mb-6 leading-tight">
                    Designed for Better Outcomes. Built for Scale.
                  </h2>

                  <p className=" mb-8 max-w-2xl mx-auto leading-relaxed">
                    Avexa OneCare empowers healthcare providers to deliver
                    connected, efficient, and patient-centric care experiences
                    by seamlessly integrating workflows, data, and digital
                    health services into a unified platform.
                  </p>

                  <Link
                    to="/platform"
                    className="inline-block btn btn-primary"
                  >
                    Explore Platform
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section> */}

        <CTASection
          heading="Designed for Better Outcomes."
          subheading="Built for Scale."
          description="Avexa OneCare empowers healthcare providers to deliver connected, efficient, and patient-centric care experiences by seamlessly integrating workflows, data, and digital health services into a unified platform."
          imageSrc="/assets/avexaOneCare/CTASection.svg"
          imageAlt="Healthcare professionals joining hands"
          buttonText="Explore Platform"
          buttonLink="/platform"
          reverse={false}
          bgColor="bg-[#fff]"
          cardbgColor="bg-[#EEF1F8]"
        />
      </div>
    </>
  );
};

export default OneCare;
